


















import { Component, Vue } from 'vue-property-decorator'

import LuciaCoreGQL from '@/data/gql'

const gql = new LuciaCoreGQL()

export interface StatisticsItem {
  name: string,
  count: number
}

export interface FullGQLStats {
  sigma: {
    stats: {
      commands: StatisticsItem[],
      events: StatisticsItem[],
      special: StatisticsItem[],
      commandCount: number,
      guildCount: number,
      channelCount: number,
      memberCount: number
    }
  }
}

export interface StatisticsRecord {
  key: string,
  name: string,
  value: number
}

interface StatisticsSegment {
  name: string,
  stats: StatisticsRecord[],
  active: boolean
}

interface SegmentItem {
  name: string,
  raw: StatisticsItem[]
}

function updateStatistics(ctx: SigmaStats) {
  ctx.loading = true
  const qry = `{
    sigma {
      stats {
        commands {
          name
          count
        }
        events {
          name
          count
        }
        special {
          name
          count
        }
        commandCount
        guildCount
        channelCount
        memberCount
      }
    }
  }`
  const req: Promise<FullGQLStats> = gql.request(qry)
  req.then((data: FullGQLStats) => {
    const deep = data.sigma.stats
    const segments: SegmentItem[] = [
      {
        name: 'Population',
        raw: [
          { name: 'guildCount', count: deep.guildCount } as StatisticsItem,
          { name: 'channelCount', count: deep.channelCount } as StatisticsItem,
          { name: 'memberCount', count: deep.memberCount } as StatisticsItem
        ]
      },
      {
        name: 'Commands',
        raw: deep.commands
      },
      {
        name: 'Events',
        raw: deep.events
      },
      {
        name: 'Special',
        raw: deep.special
      }
    ]
    segments.forEach((segment: SegmentItem) => {
      const reprocessedRecords: StatisticsRecord[] = []
      segment.raw.forEach((elem: StatisticsItem) => {
        const recordNew: StatisticsRecord = { key: elem.name, name: elem.name.toUpperCase(), value: elem.count }
        reprocessedRecords.push(recordNew)
      })
      reprocessedRecords.sort((a, b) => { return b.value - a.value })
      ctx.stats.push({
        name: segment.name,
        stats: reprocessedRecords,
        active: false
      })
    })
    ctx.loading = false
    ctx.errored = false
  })
  req.catch(() => {
    ctx.loading = false
    ctx.errored = true
  })
}

@Component
export default class SigmaStats extends Vue {
  loading = true
  errored = false
  stats: StatisticsSegment[] = []
  mounted() {
    updateStatistics(this)
  }
  numberWithCommas(x: number) {
    let y = x.toString()
    var pattern = /(-?\d+)(\d{3})/
    while (pattern.test(y)) {
      y = y.replace(pattern, '$1,$2')
    }
    return y
  }
}
